import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\SendingDomainController::returnMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:183
* @route '/app/creator/campaigns-settings/package/return'
*/
export const returnMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: returnMethod.url(options),
    method: 'get',
})

returnMethod.definition = {
    methods: ["get","head"],
    url: '/app/creator/campaigns-settings/package/return',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::returnMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:183
* @route '/app/creator/campaigns-settings/package/return'
*/
returnMethod.url = (options?: RouteQueryOptions) => {
    return returnMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::returnMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:183
* @route '/app/creator/campaigns-settings/package/return'
*/
returnMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: returnMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::returnMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:183
* @route '/app/creator/campaigns-settings/package/return'
*/
returnMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: returnMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::returnMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:183
* @route '/app/creator/campaigns-settings/package/return'
*/
const returnMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returnMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::returnMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:183
* @route '/app/creator/campaigns-settings/package/return'
*/
returnMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returnMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::returnMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:183
* @route '/app/creator/campaigns-settings/package/return'
*/
returnMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returnMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

returnMethod.form = returnMethodForm

const packageMethod = {
    return: Object.assign(returnMethod, returnMethod),
}

export default packageMethod